import { render, staticRenderFns } from "./upload-img.vue?vue&type=template&id=48349a48&scoped=true"
import script from "./upload-img.vue?vue&type=script&lang=js"
export * from "./upload-img.vue?vue&type=script&lang=js"
import style0 from "./upload-img.vue?vue&type=style&index=0&id=48349a48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48349a48",
  null
  
)

export default component.exports